module.exports = __webpack_public_path__ + "static/Wuerttemberg1-scaled-970a84463f51f27a84d1fcae166c2e28.jpeg";